import { CircularProgress } from '@mui/material';
import { useAuth } from 'context/AuthContext';
import React, { useEffect } from 'react';

const Logout = () => {
  const { logout } = useAuth();
  useEffect(() => {
    logout();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh'
      }}
    >
      <CircularProgress size={90} />
    </div>
  );
};

export default Logout;
